module.exports = __webpack_public_path__ + "img/logo_朋有.9de0aa86.png";